import { CloseOutlined } from '@ant-design/icons'
import { Form, Input, Modal } from 'antd'
import React, { memo, useEffect, useRef } from 'react'
import useThrottle from '../../../../../hook/useThrottle'

interface ModalProps {
    isOpen: boolean

    closeModal: (e: boolean) => void
    handelSaveFilter: (title: string) => void
}

const ModalSaveFilter: React.FC<ModalProps> = ({
    isOpen,
    handelSaveFilter, closeModal,
}) => {

    const formRef: any = useRef(null)
    const [form] = Form.useForm();

    const onFinish = useThrottle(async (values: any) => {
        const { title } = values
        handelSaveFilter(title)
    }, 1000)

    useEffect(() => {
        if (isOpen) {

        } else {
            form.resetFields()
        }
    }, [isOpen])

    return (
        <Form
            ref={formRef}
            form={form}
            onFinish={onFinish}
            initialValues={{ remember: true }}
        >
            <Modal
                title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
                    <span className=" custom-page-css text-344054 text-lg  font-medium">Lưu bộ lọc</span>
                    <CloseOutlined className="text-base text-8B8B8B"
                        onClick={() => closeModal(false)}
                    />
                </div>}
                open={isOpen}
                onCancel={() => closeModal(false)}
                centered
                className=" custom-page-css overflow-hidden modal-content-addCustomer ant-modal-size rounded"
                closeIcon={false}
                footer={
                    <div className='d-flex justify-end gap-4 p-2 border-t-F0F0F0 bg-FCFCFD'>
                        <button
                            className='border-none bg-096DD9 text-sm rounded-2 h-8 px-7-px font-regular text-white'
                            onClick={() => formRef?.current.submit()}
                        >
                            Lưu
                        </button>
                    </div>
                }
            >
                <div className="input-add-name px-6 py-4">

                    <Form.Item
                        label="Tên bộ lọc"
                        name="title"
                        layout="vertical"
                        rules={[{ required: true, message: 'Vui lòng nhập tên bộ lọc' }]}
                        className="m-none-form-item text-explan pb-4"
                    >
                        <Input className="plac-color" placeholder="Nhập tên bộ lọc" />
                    </Form.Item>
                </div>

            </Modal>
        </Form>
    )
}
export default memo(ModalSaveFilter)
